import type { ComponentProps } from "react"
import type { CustomIcons } from "@/v2-ui/icon/custom/icon.custom.types"
import IconCustomCompass from "@/v2-ui/icon/custom/compass/IconCustomCompass"
import {
  IconCustomAccessCode,
  IconCustomAccessCrown,
  IconCustomAccessFlag,
  IconCustomAccessLock,
  IconCustomAccessUsers,
} from "@/v2-ui/icon/custom/access/IconCustomAccess"
import IconCustomViewshed from "@/v2-ui/icon/custom/viewshed/IconCustomViewshed"
import IconCustomObjectCadastre from "@/v2-ui/icon/custom/objectCadastre/IconCustomObjectCadastre"
import IconCustomObjectAddress from "@/v2-ui/icon/custom/objectAddress/IconCustomObjectAddress"
import IconCustomObjectSection from "@/v2-ui/icon/custom/objectSection/IconCustomObjectSection"
import IconCustomObjectHousingUnit from "@/v2-ui/icon/custom/objectHousingUnit/IconCustomObjectHousingUnit"
import IconCustomObjectBuilding from "@/v2-ui/icon/custom/objectBuilding/IconCustomObjectBuilding"
import IconCustomObjectCompany from "@/v2-ui/icon/custom/objectCompany/IconCustomObjectCompany"
import IconCustomObjectPerson from "@/v2-ui/icon/custom/objectPerson/IconCustomObjectPerson"
import IconCustomObjectPlace from "@/v2-ui/icon/custom/objectPlace/IconCustomObjectPlace"
import IconCustomPropertyAgriculture from "@/v2-ui/icon/custom/PropertyAgriculture/PropertyAgriculture"
import IconCustomPropertyApartmentBlock from "@/v2-ui/icon/custom/PropertyApartmentBlock/PropertyApartmentBlock"
import IconCustomPropertyCulture from "@/v2-ui/icon/custom/PropertyCulture/PropertyCulture"
import IconCustomPropertyDetachedHouse from "@/v2-ui/icon/custom/PropertyDetachedHouse/PropertyDetachedHouse"
import IconCustomPropertyEducation from "@/v2-ui/icon/custom/PropertyEducation/PropertyEducation"
import IconCustomPropertyHealth from "@/v2-ui/icon/custom/PropertyHealth/PropertyHealth"
import IconCustomPropertyHotel from "@/v2-ui/icon/custom/PropertyHotel/PropertyHotel"
import IconCustomPropertyIndustrial from "@/v2-ui/icon/custom/PropertyIndustrial/PropertyIndustrial"
import IconCustomPropertyInfrastructure from "@/v2-ui/icon/custom/PropertyInfrastructure/PropertyInfrastructure"
import IconCustomPropertyLogistics from "@/v2-ui/icon/custom/PropertyLogistics/PropertyLogistics"
import IconCustomPropertyOffice from "@/v2-ui/icon/custom/PropertyOffice/PropertyOffice"
import IconCustomPropertyOtherResidential from "@/v2-ui/icon/custom/PropertyOtherResidential/PropertyOtherResidential"
import IconCustomPropertyParking from "@/v2-ui/icon/custom/PropertyParking/PropertyParking"
import IconCustomPropertyPublic from "@/v2-ui/icon/custom/PropertyPublic/PropertyPublic"
import IconCustomPropertyRecreation from "@/v2-ui/icon/custom/PropertyRecreation/PropertyRecreation"
import IconCustomPropertyReligion from "@/v2-ui/icon/custom/PropertyReligion/PropertyReligion"
import IconCustomPropertyRetail from "@/v2-ui/icon/custom/PropertyRetail/PropertyRetail"
import IconCustomPropertySemiDetachedHouse from "@/v2-ui/icon/custom/PropertySemiDetachedHouse/PropertySemiDetachedHouse"
import IconCustomPropertySharedLiving from "@/v2-ui/icon/custom/PropertySharedLiving/PropertySharedLiving"
import IconCustomPropertySports from "@/v2-ui/icon/custom/PropertySports/PropertySports"
import IconCustomPropertyTownhouse from "@/v2-ui/icon/custom/PropertyTownhouse/PropertyTownhouse"
import IconCustomPropertyUndeveloped from "@/v2-ui/icon/custom/PropertyUndeveloped/PropertyUndeveloped"
import IndustryA from "@/v2-ui/icon/custom/IndustryA/IndustryA"
import IndustryB from "@/v2-ui/icon/custom/IndustryB/IndustryB"
import IndustryC from "@/v2-ui/icon/custom/IndustryC/IndustryC"
import IndustryD from "@/v2-ui/icon/custom/IndustryD/IndustryD"
import IndustryE from "@/v2-ui/icon/custom/IndustryE/IndustryE"
import IndustryF from "@/v2-ui/icon/custom/IndustryF/IndustryF"
import IndustryG from "@/v2-ui/icon/custom/IndustryG/IndustryG"
import IndustryH from "@/v2-ui/icon/custom/IndustryH/IndustryH"
import IndustryI from "@/v2-ui/icon/custom/IndustryI/IndustryI"
import IndustryJ from "@/v2-ui/icon/custom/IndustryJ/IndustryJ"
import IndustryK from "@/v2-ui/icon/custom/IndustryK/IndustryK"
import IndustryL from "@/v2-ui/icon/custom/IndustryL/IndustryL"
import IndustryM from "@/v2-ui/icon/custom/IndustryM/IndustryM"
import IndustryN from "@/v2-ui/icon/custom/IndustryN/IndustryN"
import IndustryO from "@/v2-ui/icon/custom/IndustryO/IndustryO"
import IndustryP from "@/v2-ui/icon/custom/IndustryP/IndustryP"
import IndustryQ from "@/v2-ui/icon/custom/IndustryQ/IndustryQ"
import IndustryR from "@/v2-ui/icon/custom/IndustryR/IndustryR"
import IndustryS from "@/v2-ui/icon/custom/IndustryS/IndustryS"
import IndustryT from "@/v2-ui/icon/custom/IndustryT/IndustryT"
import IndustryU from "@/v2-ui/icon/custom/IndustryU/IndustryU"
import BRA from "@/v2-ui/icon/custom/BRA/BRA"
import BYA from "@/v2-ui/icon/custom/BYA/BYA"
import Floors from "@/v2-ui/icon/custom/floors/Floors"
import TransactionEstateSettlement from "@/v2-ui/icon/custom/TransactionEstateSettlement/TransactionEstateSettlement"
import TransactionForciblyDone from "@/v2-ui/icon/custom/TransactionForciblyDone/TransactionForciblyDone"
import TransactionFreeSale from "@/v2-ui/icon/custom/TransactionFreeSale/TransactionFreeSale"
import TransactionGift from "@/v2-ui/icon/custom/TransactionGift/TransactionGift"
import TransactionMerge from "@/v2-ui/icon/custom/TransactionMerge/TransactionMerge"
import TransactionOther from "@/v2-ui/icon/custom/TransactionOther/TransactionOther"
import TransactionUndisclosed from "@/v2-ui/icon/custom/TransactionUndisclosed/TransactionUndisclosed"
import ZoningCompliance from "@/v2-ui/icon/custom/ZoningCompliance/ZoningCompliance"
import EnergyRatingA from "@/v2-ui/icon/custom/EnergyRatingA/EnergyRatingA"
import EnergyRatingB from "@/v2-ui/icon/custom/EnergyRatingB/EnergyRatingB"
import EnergyRatingC from "@/v2-ui/icon/custom/EnergyRatingC/EnergyRatingC"
import EnergyRatingD from "@/v2-ui/icon/custom/EnergyRatingD/EnergyRatingD"
import EnergyRatingE from "@/v2-ui/icon/custom/EnergyRatingE/EnergyRatingE"
import EnergyRatingF from "@/v2-ui/icon/custom/EnergyRatingF/EnergyRatingF"
import EnergyRatingG from "@/v2-ui/icon/custom/EnergyRatingG/EnergyRatingG"
import EnergyCertificateBreeam from "@/v2-ui/icon/custom/EnergyCertificateBreeam/EnergyCertificateBreeam"
import EnergyCertificateLeed from "@/v2-ui/icon/custom/EnergyCertificateLeed/EnergyCertificateLeed"
import EnergyCertificateSvanemerket from "@/v2-ui/icon/custom/EnergyCertificateSvanemerket/EnergyCertificateSvanemerket"
import Company from "@/v2-ui/icon/custom/Company/Company"
import Building from "@/v2-ui/icon/custom/Building/Building"
import Address from "@/v2-ui/icon/custom/Address/Address"
import Dataset from "@/v2-ui/icon/custom/Dataset/Dataset"
import Thickness from "@/v2-ui/icon/custom/Thickness/Thickness"
import Tag from "@/v2-ui/icon/custom/Tag/Tag"
import Tag2 from "@/v2-ui/icon/custom/Tag2/Tag2"
import AddTag from "@/v2-ui/icon/custom/AddTag/AddTag"
import NearestNavigator from "@/v2-ui/icon/custom/NearestNavigator/NearestNavigator"
import IconCustomHubspot from "@/v2-ui/icon/custom/hubspot/IconCustomHubspot"
import IconCustomMixpanel from "@/v2-ui/icon/custom/mixpanel/IconCustomMixpanel"
import IconCustomEntra from "@/v2-ui/icon/custom/entra/IconCustomEntra"
import IconCustomPlacepoint from "@/v2-ui/icon/custom/placepoint/IconCustomPlacepoint"
import IconCustomCaretDownCustom from "@/v2-ui/icon/custom/caretDownCustom/IconCustomCaretDownCustom"
import IconCustomCaretUpCustom from "@/v2-ui/icon/custom/caretUpCustom/IconCustomCaretUpCustom"
import IconCustomCaretUpDownCustom from "@/v2-ui/icon/custom/caretUpDownCustom/IconCustomCaretUpDownCustom"
import IconCustomArrowUpRightLink from "@/v2-ui/icon/custom/arrowUpRightLink/IconCustomArrowUpRightLink"
import IconCustomArrowUpRightLinkBox from "@/v2-ui/icon/custom/arrowUpRightLinkBox/IconCustomArrowUpRightLinkBox"
import Grip from "@/v2-ui/icon/custom/grip/Grip"
import IconCustomNewFolder from "@/v2-ui/icon/custom/newFolder/IconCustomNewFolder"
import IconCustomAppStore from "@/v2-ui/icon/custom/appStore/IconCustomAppStore"
import Plot from "@/v2-ui/icon/custom/plot/Plot"
import PlotFilled from "@/v2-ui/icon/custom/plotFilled/PlotFilled"
import MaskOutside from "@/v2-ui/icon/custom/maskOutside/MaskOutside"
import BadgeCheckCustom from "@/v2-ui/icon/custom/badgeCheckCustom/BadgeCheckCustom"
import BadgeX from "@/v2-ui/icon/custom/badgeX/BadgeX"
import Files1 from "@/v2-ui/icon/custom/files1/Files1"
import Files2 from "@/v2-ui/icon/custom/files2/Files2"
import MapLegend from "@/v2-ui/icon/custom/mapLegend/MapLegend"
import MapLayerFilled from "@/v2-ui/icon/custom/mapLayerFilled/MapLayerFilled"
import ChevronDown from "@/v2-ui/icon/custom/chevronDown/ChevronDown"
import CanvasFocus from "@/v2-ui/icon/custom/canvasFocus/CanvasFocus"
import ZoomToFit from "@/v2-ui/icon/custom/zoomToFit/ZoomToFit"
import CompassNeedle from "@/v2-ui/icon/custom/compassNeedle/CompassNeedle"
import StreetView from "@/v2-ui/icon/custom/streetView/StreetView"
import GridToggle from "@/v2-ui/icon/custom/gridToggle/GridToggle"
import ListToggle from "@/v2-ui/icon/custom/listToggle/ListToggle"
import StarFilled from "@/v2-ui/icon/custom/starFilled/StarFilled"
import AiChat from "@/v2-ui/icon/custom/aiChat/AiChat"
import AiSuggestion from "@/v2-ui/icon/custom/aiSuggestion/AiSuggestion"
import AiRecent from "@/v2-ui/icon/custom/aiRecent/AiRecent"
import ColumnsCog from "@/v2-ui/icon/custom/columnsCog/ColumnsCog"
import MessageCirclePlus from "@/v2-ui/icon/custom/messageCirclePlus/MessageCirclePlus"
import MessageSquarePlus from "@/v2-ui/icon/custom/messageSquarePlus/MessageSquarePlus"
import AiComposerEnter from "@/v2-ui/icon/custom/aiComposerEnter/AiComposerEnter"

export type IconCustomProps = ComponentProps<"svg"> & {
  src: CustomIcons
  iconColor?: string
}
export const customIconSrcComponent = {
  compass: IconCustomCompass,
  viewshed: IconCustomViewshed,
  company: Company,
  building: Building,
  address: Address,
  dataset: Dataset,
  thickness: Thickness,
  tag: Tag,
  "tag-2": Tag2,
  "add-tag": AddTag,
  "object-cadastre": IconCustomObjectCadastre,
  "object-address": IconCustomObjectAddress,
  "object-section": IconCustomObjectSection,
  "object-housingUnit": IconCustomObjectHousingUnit,
  "object-building": IconCustomObjectBuilding,
  "object-company": IconCustomObjectCompany,
  "object-person": IconCustomObjectPerson,
  "object-place": IconCustomObjectPlace,
  "property-agriculture": IconCustomPropertyAgriculture,
  "property-apartment-block": IconCustomPropertyApartmentBlock,
  "property-culture": IconCustomPropertyCulture,
  "property-detached-house": IconCustomPropertyDetachedHouse,
  "property-education": IconCustomPropertyEducation,
  "property-health": IconCustomPropertyHealth,
  "property-hotel": IconCustomPropertyHotel,
  "property-industrial": IconCustomPropertyIndustrial,
  "property-infrastructure": IconCustomPropertyInfrastructure,
  "property-logistics": IconCustomPropertyLogistics,
  "property-office": IconCustomPropertyOffice,
  "property-other-residential": IconCustomPropertyOtherResidential,
  "property-parking": IconCustomPropertyParking,
  "property-public": IconCustomPropertyPublic,
  "property-recreation": IconCustomPropertyRecreation,
  "property-religion": IconCustomPropertyReligion,
  "property-retail": IconCustomPropertyRetail,
  "property-semi-detached-house": IconCustomPropertySemiDetachedHouse,
  "property-shared-living": IconCustomPropertySharedLiving,
  "property-sports": IconCustomPropertySports,
  "property-townhouse": IconCustomPropertyTownhouse,
  "property-undeveloped": IconCustomPropertyUndeveloped,
  "industry-a": IndustryA,
  "industry-b": IndustryB,
  "industry-c": IndustryC,
  "industry-d": IndustryD,
  "industry-e": IndustryE,
  "industry-f": IndustryF,
  "industry-g": IndustryG,
  "industry-h": IndustryH,
  "industry-i": IndustryI,
  "industry-j": IndustryJ,
  "industry-k": IndustryK,
  "industry-l": IndustryL,
  "industry-m": IndustryM,
  "industry-n": IndustryN,
  "industry-o": IndustryO,
  "industry-p": IndustryP,
  "industry-q": IndustryQ,
  "industry-r": IndustryR,
  "industry-s": IndustryS,
  "industry-t": IndustryT,
  "industry-u": IndustryU,
  "transaction-estate-settlement": TransactionEstateSettlement,
  "transaction-forcibly-done": TransactionForciblyDone,
  "transaction-free-sale": TransactionFreeSale,
  "transaction-gift": TransactionGift,
  "transaction-merge": TransactionMerge,
  "transaction-other": TransactionOther,
  "transaction-undisclosed": TransactionUndisclosed,
  "transaction-stock": TransactionFreeSale,
  bra: BRA,
  bya: BYA,
  floors: Floors,
  "zoning-compliance": ZoningCompliance,
  "energy-rating-A": EnergyRatingA,
  "energy-rating-B": EnergyRatingB,
  "energy-rating-C": EnergyRatingC,
  "energy-rating-D": EnergyRatingD,
  "energy-rating-E": EnergyRatingE,
  "energy-rating-F": EnergyRatingF,
  "energy-rating-G": EnergyRatingG,
  "energy-certificate-breeam": EnergyCertificateBreeam,
  "energy-certificate-leed": EnergyCertificateLeed,
  "energy-certificate-svanemerket": EnergyCertificateSvanemerket,
  "nearest-navigator": NearestNavigator,
  hubspot: IconCustomHubspot,
  mixpanel: IconCustomMixpanel,
  entra: IconCustomEntra,
  placepoint: IconCustomPlacepoint,
  "caret-down-custom": IconCustomCaretDownCustom,
  "caret-up-custom": IconCustomCaretUpCustom,
  "caret-up-down-custom": IconCustomCaretUpDownCustom,
  arrowUpRightLink: IconCustomArrowUpRightLink,
  arrowUpRightLinkBox: IconCustomArrowUpRightLinkBox,
  grip: Grip,
  "new-folder": IconCustomNewFolder,
  appStore: IconCustomAppStore,
  plot: Plot,
  "plot-filled": PlotFilled,
  "mask-outside": MaskOutside,
  "badge-check-custom": BadgeCheckCustom,
  "badge-x": BadgeX,
  "files-1": Files1,
  "files-2": Files2,
  "map-legend": MapLegend,
  "map-layer-filled": MapLayerFilled,
  "chevron-down": ChevronDown,
  "canvas-focus": CanvasFocus,
  "zoom-to-fit": ZoomToFit,
  "compass-needle": CompassNeedle,
  "street-view": StreetView,
  "grid-toggle": GridToggle,
  "list-toggle": ListToggle,
  "star-filled": StarFilled,
  "ai-chat": AiChat,
  "ai-suggestion": AiSuggestion,
  "ai-recent": AiRecent,
  "access-lock": IconCustomAccessLock,
  "access-crown": IconCustomAccessCrown,
  "access-code": IconCustomAccessCode,
  "access-flag": IconCustomAccessFlag,
  "access-users": IconCustomAccessUsers,
  "columns-cog": ColumnsCog,
  "message-circle-plus": MessageCirclePlus,
  "message-square-plus": MessageSquarePlus,
  "ai-composer-enter": AiComposerEnter,
}
function IconCustom(props: IconCustomProps) {
  const { src, iconColor, ...svgProps } = props

  const IconCustomSrc = customIconSrcComponent[src]

  return <IconCustomSrc fill={iconColor} {...svgProps} />
}

export default IconCustom
